<script>
  import { afterUpdate } from 'svelte';
  import { format } from 'svelte-i18n';
  import { formatDistance } from 'date-fns';

  import { BannerCell, CategoriesCell, TagsCell } from '@client/pages/marketing/campaigns/manage/cell-formatters';

  import { formatDate } from '@common/utils/dates';

  export let row = {};

  let timeRemaining = $format('label.NOT_SCHEDULED');
  let timeClass = null;

  afterUpdate(() => {
    timeRemaining = $format('label.NOT_SCHEDULED');
    timeClass = null;

    if (row?.enableschedule && row?.schedule) {
      const endDate = new Date(row.schedule?.endDate);
      const startDate = new Date(row.schedule?.startDate);

      const start = startDate.getTime();
      const end = endDate.getTime();
      const now = new Date().getTime();

      if (start <= now && end >= now) {
        timeRemaining = $format('label.CAMPAIGN_STARTED', { values: { time: formatDistance(now, endDate) } });
        timeClass = 'active';
      } else if (start > now) {
        timeRemaining = $format('label.CAMPAIGN_UPCOMING');
        timeClass = 'upcoming';
      } else if (start < now && end < now) {
        timeRemaining = $format('label.CAMPAIGN_EXPIRED');
        timeClass = 'expired';
      }
    }
  });
</script>

<div class="banner">
  <BannerCell {row} />
</div>

<div class="rulename">
  {row.rulename}
</div>

<div class="schedule">
  {#if row.enableschedule && row.schedule}
    {formatDate(row.schedule.startDate, 'MMMM d, yy @ h a')} -
    {formatDate(row.schedule.endDate, 'MMMM d, yy @ h a')}
  {/if}
</div>

<small class="time-remaining {timeClass}">{timeRemaining}</small>

{#if row.tags.length}
  <div class="section">
    <small class="bold">{$format('label.TAGS')}</small>
  </div>
  <TagsCell bind:row />
{/if}

{#if row.categories}
  <div class="section">
    <small class="bold">{$format('label.CATEGORIES')}</small>
  </div>
  <CategoriesCell bind:row />
{/if}

<style lang="scss">
  .banner {
    display: none;
  }

  .rulename {
    font-weight: var(--font-weight-medium);
    word-break: break-all;
  }

  .schedule {
    color: var(--color-gray-900);
    font-size: var(--font-size-medium);
    padding-top: var(--padding-small);

    .none {
      color: var(--color-gray-600);
      font-size: var(--font-size-medium);
    }
  }

  .time-remaining {
    background-color: var(--color-gray-200);
    border-radius: var(--border-radius-base);
    display: inline-block;
    font-size: var(--font-size-small);
    margin-top: var(--margin-base);
    padding: var(--padding-small) var(--padding-base);
    text-transform: capitalize;

    &.active {
      background-color: #fdf4e5;
    }

    &.upcoming {
      background-color: #b6efd7;
    }

    &.expired {
      background-color: var(--color-red-100);
    }
  }

  .section {
    margin: var(--margin-base) 0;
  }

  @media only screen and (max-width: 1550px) {
    .banner {
      display: block;
      margin-bottom: var(--margin-large);
    }
  }
</style>
